import axios from 'axios';
import { getGuestSession } from './store';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, withCredentials: true });

client.interceptors.request.use((config) => {
  const guest = getGuestSession();
  if (guest) config.headers['X-Guest-Session'] = guest;
  return config;
});

export const api = {
  // auth
  me: () => client.get('/auth/me').then((r) => r.data),
  session: (session_id) => client.post('/auth/session', { session_id }).then((r) => r.data),
  logout: () => client.post('/auth/logout').then((r) => r.data),
  updateProfile: (data) => client.patch('/profile', data).then((r) => r.data),

  // contacts
  listContacts: () => client.get('/contacts').then((r) => r.data),
  createContact: (data) => client.post('/contacts', data).then((r) => r.data),
  updateContact: (id, data) => client.patch(`/contacts/${id}`, data).then((r) => r.data),
  deleteContact: (id) => client.delete(`/contacts/${id}`).then((r) => r.data),

  // rides
  createRide: (data) => client.post('/rides', data).then((r) => r.data),
  listRides: () => client.get('/rides').then((r) => r.data),
  getRide: (id) => client.get(`/rides/${id}`).then((r) => r.data),
  updateRide: (id, data) => client.patch(`/rides/${id}`, data).then((r) => r.data),
  deleteRide: (id) => client.delete(`/rides/${id}`).then((r) => r.data),
  postLocation: (id, point) => client.post(`/rides/${id}/locations`, point).then((r) => r.data),
  getLocations: (id) => client.get(`/rides/${id}/locations`).then((r) => r.data),
  addPhoto: (id, data) => client.post(`/rides/${id}/photos`, data).then((r) => r.data),
  deletePhoto: (id, photoId) => client.delete(`/rides/${id}/photos/${photoId}`).then((r) => r.data),
  addSafetyEvent: (id, data) => client.post(`/rides/${id}/safety-events`, data).then((r) => r.data),
  setVehicle: (id, data) => client.post(`/rides/${id}/vehicle`, data).then((r) => r.data),
  getVehicle: (plate) => client.get(`/vehicles/${encodeURIComponent(plate)}`).then((r) => r.data),
  rateVehicle: (plate, data) => client.post(`/vehicles/${encodeURIComponent(plate)}/rate`, data).then((r) => r.data),
  submitFeedback: (rideId, data) => client.post(`/rides/${rideId}/feedback`, data).then((r) => r.data),
  listPlaces: () => client.get('/places').then((r) => r.data.places),
  savePlace: (data) => client.post('/places', data).then((r) => r.data),
  renamePlace: (id, label) => client.patch(`/places/${id}`, { label }).then((r) => r.data),
  deletePlace: (id) => client.delete(`/places/${id}`).then((r) => r.data),
  createShare: (id) => client.post(`/rides/${id}/share`, {}).then((r) => r.data),
  revokeShare: (id) => client.post(`/rides/${id}/share/revoke`).then((r) => r.data),

  // public (no auth)
  publicRide: (token) => axios.get(`${API}/r/${token}`).then((r) => r.data),
  publicOpened: (token) => axios.post(`${API}/r/${token}/opened`).then((r) => r.data),

  // misc
  config: () => client.get('/config').then((r) => r.data),
  adminVerify: (passcode) => client.post('/admin/verify', { passcode }).then((r) => r.data),
  adminSetSettings: (passcode, family_mode_enabled) => client.post('/admin/settings', { passcode, family_mode_enabled }).then((r) => r.data),
  emergencyNumbers: (country = 'PH') => client.get(`/emergency-numbers?country=${country}`).then((r) => r.data),
  plans: () => client.get('/plans').then((r) => r.data),
  upgrade: () => client.post('/subscription/upgrade').then((r) => r.data),
  familyDashboard: () => client.get('/family/dashboard').then((r) => r.data),
  familyInvite: () => client.get('/family/invite').then((r) => r.data),
  familyInviteRegenerate: () => client.post('/family/invite/regenerate').then((r) => r.data),
  familyInviteInfo: (token) => axios.get(`${API}/family/join/${token}`).then((r) => r.data),
  familyJoin: (token, data) => client.post(`/family/join/${token}`, data).then((r) => r.data),
  familyMembership: () => client.get('/family/membership').then((r) => r.data),
  familyRemoveMember: (memberId) => client.post(`/family/members/${memberId}/remove`).then((r) => r.data),
  track: (event, props = {}) => client.post('/analytics/event', { event, props }).catch(() => {}),
};

export default client;
